import { Box, Button, Typography } from "@mui/joy";
import { AlertCircle, Save } from "lucide-react";

type UnsavedChangesBannerProps = {
    open: boolean;
    syncing?: boolean;
    onSave: () => void;
};

export function UnsavedChangesBanner({
    open,
    syncing = false,
    onSave,
}: UnsavedChangesBannerProps) {
    if (!open) {
        return null;
    }

    return (
        <Box
            sx={{
                position: "fixed",
                left: 0,
                right: 0,
                bottom: 80,
                zIndex: 1200,
                display: "flex",
                justifyContent: "center",
                px: 2,
                pointerEvents: "none",
            }}
        >
            <Box
                sx={{
                    pointerEvents: "auto",
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    alignItems: { xs: "stretch", sm: "center" },
                    gap: 1.5,
                    px: 2.5,
                    py: 1.75,
                    width: "100%",
                    maxWidth: 820,
                    minWidth: { sm: 640 },
                    borderRadius: "4px",
                    border: "1px solid",
                    borderColor: "warning.outlinedBorder",
                    bgcolor: "warning.softBg",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.25,
                        flex: 1,
                    }}
                >
                    <Box
                        sx={{
                            color: "warning.500",
                            bgcolor: "warning.softActiveBg",
                            borderRadius: "50%",
                            width: 32,
                            height: 32,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                        }}
                    >
                        <AlertCircle size={18} />
                    </Box>
                    <Box>
                        <Typography level="title-sm" color="warning">
                            Unsaved changes
                        </Typography>
                        <Typography level="body-xs" sx={{ color: "text.secondary" }}>
                            You have unsaved changes. Save now or use Save &
                            Continue below.
                        </Typography>
                    </Box>
                </Box>

                <Button
                    size="sm"
                    variant="solid"
                    color="warning"
                    loading={syncing}
                    onClick={onSave}
                    startDecorator={<Save size={16} />}
                    sx={{ borderRadius: "4px", flexShrink: 0, minWidth: 108 }}
                >
                    Save now
                </Button>
            </Box>
        </Box>
    );
}
